<script lang="ts">
	import Modal from "src/components/common/modal.svelte";
	import { GetMentorByCpf } from "src/graphql-operations";
	import { formatName } from "src/helpers/format-name";
	import { NavItemProps } from "src/types/profiles/forms/modal-item";
	import ModalItem from "./modal-item.svelte";

	export let modal: Modal;
	export let cpf: string;
	export let name: string;
	export let photo: string;

	let hasTags = true;

	let nav: NavItemProps[] = [
		{
			modal,
			type: "platform",
			title: "Plataforma TXM Business",
			description:
				"Acesse o conteúdo da metodologia TXM, acompanhe seu(s) projeto(s)  e explore as ferramentas de cocriação.",
			disabled: false,
		},
		{
			modal,
			type: "mentoring",
			url: "/mentor",
			title: "Consultar mentorias solicitadas",
			description:
				"Veja horários solicitados para mentorias com você e marque as suas disponibilidades.",
			disabled: false,
		},
		{
			modal,
			type: "profile",
			url: "/profile#mentor-tags",
			title: "Deseja atualizar suas áreas de conhecimento?",
			description:
				"Acesse seu perfil e atualize as tags com as áreas em que você deseja mentorar.",
			disabled: false,
		},
	];

	$: if (!hasTags) {
		nav = nav.filter(({ type }) => type !== "profile");
		nav.map((item) => (item.disabled = true));
	}

	$: name = formatName(name);

	$: if (cpf) {
		GetMentorByCpf({ variables: { cpf } }).subscribe(({ loading, data }) => {
			if (loading || !data) return;
			const mentors = data.mentors;
			hasTags = mentors.length > 0 && mentors[0]?.tags?.length > 0;
		});
	}
</script>

<Modal
	bind:this={modal}
	bgClass="!opacity-80"
	disabled={!hasTags}
	outerClass="w-full h-full flex flex-col gap-5 overflow-y-auto md:w-auto md:h-auto md:rounded-[37px] bg-white items-center px-5 sm:px-14 py-5 sm:py-10 2xl:p-14 md:max-w-[700px]"
	roundedNone
>
	<img
		class="size-[88px] min-h-[88px] rounded-full object-cover"
		alt=""
		src={photo}
	/>

	<div class="flex flex-col sm:gap-10">
		<h1
			class="text-center text-3xl font-bold leading-[40px] text-gray-brand-500 sm:text-5xl"
		>
			Olá, <span class="text-think-500">{name}!</span>
		</h1>
		<p class="text-center text-lg font-semibold leading-6 text-neutral-700">
			Escolha qual área você deseja visitar:
		</p>
	</div>
	<div class="flex w-full flex-col gap-[25px]">
		{#if !hasTags}
			<div
				class="flex w-full flex-col items-start gap-2 sm:flex-row sm:items-center"
			>
				<div class="size-[30px]">
					<svg
						class=""
						fill="none"
						height="30"
						viewBox="0 0 30 30"
						width="30"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M15.0625 23.75L18.625 20.2188L15.0625 16.6875L13.75 18L15.0938 19.3438C14.5104 19.3646 13.9429 19.2708 13.3913 19.0625C12.8396 18.8542 12.3446 18.5312 11.9063 18.0938C11.4896 17.6771 11.1717 17.1979 10.9525 16.6562C10.7333 16.1146 10.6242 15.5729 10.625 15.0312C10.625 14.6771 10.6721 14.3229 10.7663 13.9688C10.8604 13.6146 10.9904 13.2708 11.1563 12.9375L9.78125 11.5625C9.42708 12.0833 9.16667 12.6354 9 13.2188C8.83333 13.8021 8.75 14.3958 8.75 15C8.75 15.7917 8.90625 16.5729 9.21875 17.3438C9.53125 18.1146 9.98959 18.8021 10.5938 19.4062C11.1979 20.0104 11.875 20.4638 12.625 20.7663C13.375 21.0688 14.1458 21.23 14.9375 21.25L13.75 22.4375L15.0625 23.75ZM20.2188 18.4375C20.5729 17.9167 20.8333 17.3646 21 16.7812C21.1667 16.1979 21.25 15.6042 21.25 15C21.25 14.2083 21.0987 13.4217 20.7962 12.64C20.4937 11.8583 20.0408 11.1658 19.4375 10.5625C18.8342 9.95917 18.1517 9.51125 17.39 9.21875C16.6283 8.92625 15.8525 8.78042 15.0625 8.78125L16.25 7.5625L14.9375 6.25L11.375 9.78125L14.9375 13.3125L16.25 12L14.875 10.625C15.4375 10.625 16.0104 10.7346 16.5938 10.9537C17.1771 11.1729 17.6771 11.4904 18.0938 11.9062C18.5104 12.3221 18.8283 12.8013 19.0475 13.3438C19.2667 13.8863 19.3758 14.4279 19.375 14.9688C19.375 15.3229 19.3283 15.6771 19.235 16.0312C19.1417 16.3854 19.0113 16.7292 18.8438 17.0625L20.2188 18.4375ZM15 27.5C13.2708 27.5 11.6458 27.1717 10.125 26.515C8.60417 25.8583 7.28125 24.9679 6.15625 23.8438C5.03125 22.7196 4.14084 21.3967 3.485 19.875C2.82917 18.3533 2.50083 16.7283 2.5 15C2.49917 13.2717 2.8275 11.6467 3.485 10.125C4.1425 8.60333 5.03292 7.28042 6.15625 6.15625C7.27958 5.03208 8.6025 4.14167 10.125 3.485C11.6475 2.82833 13.2725 2.5 15 2.5C16.7275 2.5 18.3525 2.82833 19.875 3.485C21.3975 4.14167 22.7204 5.03208 23.8438 6.15625C24.9671 7.28042 25.8579 8.60333 26.5163 10.125C27.1746 11.6467 27.5025 13.2717 27.5 15C27.4975 16.7283 27.1692 18.3533 26.515 19.875C25.8608 21.3967 24.9704 22.7196 23.8438 23.8438C22.7171 24.9679 21.3942 25.8587 19.875 26.5162C18.3558 27.1737 16.7308 27.5017 15 27.5Z"
							fill="#FFB805"
						/>
					</svg>
				</div>
				<h3
					class="w-full text-base font-bold text-warning-700 sm:w-2/3 sm:text-xs"
				>
					Parece que já faz um tempo que você não atualiza suas áreas de
					conhecimento no seu perfil, por favor, atualize suas informações antes
					de continuar:
				</h3>
				<a
					class="button w-full min-w-[180px] text-think-500 sm:w-[180px]"
					href="/profile#mentor-tags"
				>
					Acessar Perfil
				</a>
			</div>
		{/if}
		{#each nav as { title, description, url, type, disabled }}
			<ModalItem {description} {disabled} {modal} {title} {type} {url} />
		{/each}
	</div>
</Modal>
